"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Closable = Closable;
const jsx_runtime_1 = require("react/jsx-runtime");
const embeds_1 = require("../embeds/index.js");
const launcher_provider_1 = require("./launcher-provider");
function Closable({ children }) {
    const embed = (0, embeds_1.useEmbed)();
    const launcher = (0, launcher_provider_1.useLauncher)();
    if (embed.isEmbed && !launcher)
        return null;
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
}
